import React from 'react';

import { Box, Paper, Skeleton, Stack, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

/**
 * Headline number with a tinted icon, so neighbouring figures are told apart at a glance.
 * color is a palette key: primary, secondary, success, warning, error, info.
 */
const StatTile = ({ label, value, icon, color = 'primary', valueColor, loading, footer }) => (
    <Paper variant="outlined" sx={ { p: 2.5, height: '100%' } }>
        <Stack direction="row" spacing={ 2 } alignItems="flex-start">
            <Box sx={ theme => ({
                width: 44,
                height: 44,
                flexShrink: 0,
                borderRadius: 2.5,
                display: 'grid',
                placeItems: 'center',
                color: theme.palette[color].main,
                backgroundColor: alpha(theme.palette[color].main, 0.12)
            }) }>
                { icon }
            </Box>
            <Box sx={ { minWidth: 0, flexGrow: 1 } }>
                <Typography variant="body2" color="text.secondary" sx={ { fontWeight: 500 } }>{ label }</Typography>
                {
                    loading
                        ? <Skeleton width="60%" height={ 40 }/>
                        : <Typography sx={ { fontSize: 26, fontWeight: 700, lineHeight: 1.3 } } color={ valueColor || 'text.primary' }>{ value }</Typography>
                }
                { footer && <Box sx={ { minHeight: 22 } }>{ footer }</Box> }
            </Box>
        </Stack>
    </Paper>
);

export default StatTile;
